import { apiGet, apiPost, apiPut, apiDelete } from "../../api/client";
import { ICompany } from "../../types";

/**
 * REST client for the `companies` resource. Replaces direct Firestore access so
 * company data is read and written exclusively through the API.
 */

const COMPANIES_PATH = "/api/companies/";

/** Serialized company payload sent as a JSON request body (e.g. `Company.data()`). */
type CompanyPayload = Record<string, unknown>;

/** Full company list for a workspace (no pagination — current default). */
export const listCompanies = async (
  token: string,
  workspaceId: string,
): Promise<ICompany[]> => {
  const envelope = await apiGet(token, COMPANIES_PATH, workspaceId);
  return (envelope?.data as ICompany[]) ?? [];
};

export const createCompany = async (
  token: string,
  workspaceId: string,
  company: CompanyPayload,
): Promise<ICompany> => {
  const envelope = await apiPost(token, COMPANIES_PATH, company, workspaceId);
  return envelope?.data as ICompany;
};

export const updateCompany = async (
  token: string,
  workspaceId: string,
  companyId: string,
  company: CompanyPayload,
): Promise<ICompany> => {
  const envelope = await apiPut(
    token,
    `${COMPANIES_PATH}${companyId}`,
    company,
    workspaceId,
  );
  return envelope?.data as ICompany;
};

export const deleteCompany = async (
  token: string,
  workspaceId: string,
  companyId: string,
): Promise<void> => {
  await apiDelete(token, `${COMPANIES_PATH}${companyId}`, workspaceId);
};
